'use client';

import type { PropsWithChildren } from 'react';

import { createContext, useContext } from 'react';

type ScrollToContactCardContextType = {
  scrollToContactCard: () => void;
};

export const ScrollToContactCardContext = createContext<
  ScrollToContactCardContextType | undefined
>(undefined);

export const useScrollToContactCard = () => {
  const ctx = useContext(ScrollToContactCardContext);
  if (!ctx)
    throw new Error(
      'useScrollToContactCard must be used within ScrollToContactCardProvider'
    );
  return ctx.scrollToContactCard;
};

export const ScrollToContactCardProvider = ({
  children,
  scrollToContactCard,
}: PropsWithChildren & {
  scrollToContactCard: () => void;
}) => (
  <ScrollToContactCardContext.Provider value={{ scrollToContactCard }}>
    {children}
  </ScrollToContactCardContext.Provider>
);
